import { MAX_TEXT_LENGTH } from "./assignmentUtils";

// Free text an admin types for a vehicle or driver we hold no record of. A
// `prefix` is fixed furniture inside the field — shown, never typed over, never
// deleted — so the value stays just the part that varies.
const AssignmentTextField = ({ label, value, placeholder, prefix = "", onChange, maxLength = MAX_TEXT_LENGTH }) => (
    <label className="tw:flex tw:w-full tw:flex-col tw:gap-1">
        <span className="tw:font-hanken-grotesk tw:text-[13px] tw:font-[400] tw:text-[#8D8D8D]">{label}</span>
        <div className="tw:flex tw:h-[52px] tw:w-full tw:items-center tw:overflow-hidden tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white tw:focus-within:border-[#DBBE78]">
            {prefix ? (
                <span
                    aria-hidden="true"
                    className="tw:shrink-0 tw:select-none tw:border-r tw:border-[#E8E8E8] tw:bg-[#F9F9F9] tw:px-3 tw:font-hanken-grotesk tw:text-[14px] tw:leading-[52px] tw:text-[#4E4E4E]"
                >
                    {prefix}
                </span>
            ) : null}
            <input
                type="text"
                value={value}
                placeholder={placeholder}
                maxLength={maxLength}
                autoComplete="off"
                onChange={(event) => onChange(event.target.value)}
                className="tw:h-full tw:w-full tw:min-w-0 tw:border-0 tw:bg-transparent tw:px-3 tw:font-hanken-grotesk tw:text-[14px] tw:text-[#282828] tw:outline-none"
            />
        </div>
    </label>
);

export default AssignmentTextField;
